import React from 'react'

export const TableGenericContext = React.createContext()
